import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['+70 libros, manuales y cursos en PDF', 'Guías prácticas listas para aplicar desde el día 1', 'Manuales para uso personal y profesional', 'Acceso permanente: pagás una vez y es tuyo para siempre', 'Descarga inmediata en segundos'];
export function WhatYouGetSection() {
  return <section className="py-12 bg-white" data-id="element-254">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-255">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-serif font-bold text-center text-black mb-8" data-id="element-256">
          Con tu compra descargás al instante
        </motion.h2>

        <div className="space-y-3" data-id="element-257">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-4 p-4 bg-gray-50 border border-gray-100 rounded-xl" data-id="element-258">
              <CheckCircle2 className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-259" />
              <span className="text-base font-medium text-gray-800" data-id="element-260">
                {benefit}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}